import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], }).then(() => {
  if ('serviceWorker' in navigator && environment.production) {
    navigator.serviceWorker.register('jt-service-worker.js').then(function (reg) {
    }).catch(function (e) {
      console.error('Error during service worker registration:', e);
    });


  }
}).catch(err => console.log(err));
